var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStethescope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_icon_Stethescope",
    "data-name": "Controls/icon/Stethescope",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2904",
    "data-name": "Group 2904",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2323",
    "data-name": "Rectangle 2323",
    width: 38,
    height: 38,
    transform: "translate(0 0)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2903",
    "data-name": "Group 2903",
    transform: "translate(6 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3778",
    "data-name": "Path 3778",
    d: "M40.02,30.5a3.445,3.445,0,1,0-4.411,3.251v2.473a5.437,5.437,0,0,1-10.873,0V27.545a11.652,11.652,0,0,0,6.894-3.659,1.383,1.383,0,0,0,.35-.852l.367-.429c1.025-1.2,1.119-3.536,1.128-4.011V10.72a2.625,2.625,0,0,0-2.856-2.658h-.247a1.456,1.456,0,1,0,0,2.01h.246c.822,0,.822.421.822.648v7.856a5.7,5.7,0,0,1-.646,2.73l-.21.245a1.421,1.421,0,0,0-1.084.466A8.459,8.459,0,0,1,23.747,24.8a8.459,8.459,0,0,1-5.753-2.779,1.421,1.421,0,0,0-1.084-.466l-.21-.245a5.623,5.623,0,0,1-.646-2.713V10.72c0-.227,0-.648.822-.648h.288a1.456,1.456,0,1,0,0-2.01h-.288A2.625,2.625,0,0,0,14.02,10.72v7.893c.009.457.1,2.8,1.128,3.992l.367.429a1.38,1.38,0,0,0,.351.852A11.671,11.671,0,0,0,22.7,27.54v8.689a7.471,7.471,0,0,0,14.94,0v-2.5A3.4,3.4,0,0,0,40.02,30.5ZM29.309,9.318a.25.25,0,1,1,.253-.251A.253.253,0,0,1,29.309,9.318Zm-11.083-.5a.25.25,0,1,1-.254.25A.251.251,0,0,1,18.227,8.817ZM16.474,23.353a.6.6,0,0,1-.15-.415l.689-.576a.6.6,0,0,1,.373.19A9.333,9.333,0,0,0,23.747,25.6a9.333,9.333,0,0,0,6.362-3.049.6.6,0,0,1,.374-.19l.688.576a.593.593,0,0,1-.151.415,10.489,10.489,0,0,1-7.274,3.454A10.489,10.489,0,0,1,16.474,23.353Zm20.1,9.351A2.2,2.2,0,1,1,38.8,30.5,2.214,2.214,0,0,1,36.576,32.7Z",
    transform: "translate(-14.02 -7.611)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    d: "M41.537,34.968a.9.9,0,1,0,.911.9A.905.905,0,0,0,41.537,34.968Z",
    transform: "translate(-18.982 -12.974)",
    fill: "#75787b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethescope);
export default __webpack_public_path__ + "static/media/Stethescope.97591c5f18ba7c94efa78fa8e060a993.svg";
export { ForwardRef as ReactComponent };